import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import AppNotification from 'Components/AppNotification/AppNotification.jsx';
import * as KeyConstants from 'Utils/constants/keyConstants.js';
// import { NavLink } from 'react-router-dom';
import './DropDownList.scss';
import PinIcon from '../icons/PinIcon/PinIcon';

class DropDownList extends Component {
  constructor(props) {
    super(props);
    this.toggleDropDownList = this.toggleDropDownList.bind(this);
    this.selectItem = this.selectItem.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.enableDropDownList = this.enableDropDownList.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    // this.filterdropDownListList = this.filterdropDownListList.bind(this);

    this.state = {
      dropDownListVisible: false,
      filteredDropDownList: [],
    };
  }

  componentDidMount() {
    // this.filterdropDownListList(this.props.dropDownListList);
    let dropDownList = this.props.dropDownList;
    if(this.props.callingComponent && dropDownList.length > 0) {
      dropDownList[0].focus = false;
    }
    if(!this.props.callingComponent) {
      dropDownList[0].focus = this.props.isFocus;
    }
    this.setState({
      selectedRole: this.props.selectedItemText,
      dropDownList: dropDownList,
    });
    document.addEventListener('mousedown', this.handleOutsideClick);
    document.addEventListener('keydown', this.onKeyPress);
    document.addEventListener('keypress', this.onKeyPress);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyPress);
    document.removeEventListener('keypress', this.onKeyPress);
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }

  onKeyPress(event) {
    const eventCode = event.code ? (event.code + "_" + event.ctrlKey) : event.key + "_" + event.ctrlKey;
    var dropDownList = this.state.dropDownList;
    if (this.state !== undefined && this.state.dropDownListVisible) {
      switch (eventCode) {
        case KeyConstants.UP_ARROW_BUTTON: // if the UP key is pressed
        case KeyConstants.UP_KEY_CODE_ARROW_BUTTON:
          for (let i = dropDownList.length - 1; i >= 0; i--) {
            if (!dropDownList[i].focus) {
              dropDownList[i].focus = true;
              dropDownList[i = (i - dropDownList.length - 1) ? 0 : i - 1].focus = false;
              event.preventDefault();
              this.setState({
                dropDownList
              })
              break;
            } else if (dropDownList[i].focus) {
              dropDownList[i].focus = false;
              dropDownList[i = (i - dropDownList.length - 1) ? 0 : i - 1].focus = true;
              event.preventDefault();
              this.setState({
                dropDownList
              })
              break;
            }
          }
          break;
        case KeyConstants.DOWN_ARROW_BUTTON:
        case KeyConstants.DOWN_KEY_CODE_ARROW_BUTTON:
          for (let i = 0; i < dropDownList.length; i++) {
            if (!dropDownList[i].focus) {
              dropDownList[i].focus = true;
              dropDownList[i == dropDownList.length - 1 ? 0 : i + 1].focus = false;
              event.preventDefault();
              this.setState({
                dropDownList
              })
              break;
            } else if (dropDownList[i].focus) {
              dropDownList[i].focus = false;
              dropDownList[i == dropDownList.length - 1 ? 0 : i + 1].focus = true;
              event.preventDefault();
              this.setState({
                dropDownList
              })
              break;
            }
          }
          break;
        case KeyConstants.ENTER_BUTTON:
        case KeyConstants.ENTER_NUMPAD_BUTTON:
          for (let i = 0; i < dropDownList.length; i++) {
            if (dropDownList[i].focus) {
              dropDownList[i].focus = false;
              this.setState(({
                dropDownListVisible: false,
                dropDownList
              }));
              this.props.selectDropdownItem(dropDownList[i]);
              break;
            }
          }
          break;

      }
    }
  }
  handleOutsideClick(event) {
    if (this.dropDownList && !this.dropDownList.contains(event.target) && this.state.dropDownListVisible) {
      this.toggleDropDownList();
    }
  }

  componentWillReceiveProps(newProps) {
    if (this.props !== undefined && JSON.stringify(this.props.dropDownList) != JSON.stringify(newProps.dropDownList)) {
      this.setState({
        dropDownList: newProps.dropDownList,
      });
    }
    if (this.props.selectedItemText != newProps.selectedItemText) {
      this.setState({
        selectedRole: newProps.selectedItemText,
      });
    }
  }

  toggleDropDownList(event) {
    this.setState({
      dropDownListVisible: !this.state.dropDownListVisible,
    });
  }

  selectItem(item) {
    this.setState(({
      dropDownListVisible: false,
    }));
    this.props.selectDropdownItem(item);
  }
  enableDropDownList = (event) => {
    const eventCode = event.code ? (event.code + "_" + event.ctrlKey) : event.key + "_" + event.ctrlKey;
    if (eventCode == KeyConstants.DOWN_ARROW_BUTTON || eventCode == KeyConstants.DOWN_KEY_CODE_ARROW_BUTTON) {
      this.setState(({
        dropDownListVisible: true,
      }));
      event.preventDefault();
    }
  }

  render() {
    return (
      <div style={this.props.actionPositionStyle} ref={(ref) => { this.dropDownList = ref; }}>
        <div
          role="button"
          tabIndex='0'
          className="dropDownList-dropdown-trigger"
          onClick={this.props.disable ? null : this.toggleDropDownList}
          onKeyUp={(event) => this.enableDropDownList(event)}
          aria-expanded={this.state.dropDownListVisible}
          style={this.props.wrapperButtonStyle}
        >
          <span className="gd-report-runner__filter-toggle">{this.state.selectedRole}</span>
        </div>

        {this.state.dropDownListVisible ? (<div >
          <ul className="dropDownLists-dropdown" style={this.props.extraStyle}>
            {this.props.dropDownList !== undefined && this.props.dropDownList.map((item, index) => {
              return (
                <li className={item.focus !== undefined && item.focus ? "vertical-nav-item" : "vertical-nav-item"} key={index} tabIndex="0" >
                  <div
                    className="vertical-nav-action"
                    role="button"
                    onClick={() => this.selectItem(item)}
                    key={index}
                  >
                    <span id="label" className="vertical-nav-label">
                      {item.text}
                      {item.value?.isDefaultRegion && <PinIcon/>}
                    </span>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>) : (null)}

      </div>

    );
  }
}
DropDownList.propTypes = {
  extraClass: PropTypes.string,
  dropDownList: PropTypes.array.isRequired,
  isFocus: PropTypes.bool,
};

DropDownList.defaultProps = {
  extraClass: '',
  extraStyle: {},
  dropDownList: [],
  wrapperButtonStyle: {},
  isFocus: true,
};

export function findItem(list, selectedValue) {
  return list.find((item) => item.text === selectedValue);
}

export default DropDownList;
